import alert_mixin from "@/utils/mixins/alert_mixin";

export default {
  name: "ManualVerification",
  mixins: [alert_mixin],
  data: () => ({
    selected_all: false,
    active_file_tab: 'employee',
    active_section_tab: 'employment-info',
    file_tabs: {
      employee: [
        {
          id: 'employment-info',
          label: 'Employee Details',
          questions: [
              { label: 'What is your full name?', answer: 'John Doe' },
              { label: 'What is your employee ID?', answer: 'EMP12345' },
              { label: 'What is your job title?', answer: 'Software Engineer' },
              { label: 'What is your department?', answer: 'IT' },
              { label: 'What is your hire date?', answer: '2020-01-15' },
              { label: 'What is your salary?', answer: '$75,000' },
          ],
        },

        {
          id: 'introduction',
          label: 'Introduction',
          questions: [
              { label: 'What is your favorite movie?', answer: 'Inception' },
              { label: 'What is your favorite book?', answer: '1984' },
              { label: 'What is your favorite hobby?', answer: 'Reading' },
              { label: 'What is your favorite sport?', answer: 'Basketball' },
          ],
        },

        {
          id: 'personal-info',
          label: 'Personal Information',
          questions: [
              { label: 'What is your address?', answer: '123 Main St' },
              { label: 'What is your phone number?', answer: '555-1234' },
              { label: 'What is your email?', answer: 'john.doe@example.com' },
              { label: 'What is your marital status?', answer: 'Single' },
              { label: 'What is your nationality?', answer: 'American' },
              { label: 'What is your date of birth?', answer: '1990-05-20' },
          ],
        },
        
      ],
      trust_details: [
        {
            id: 'contract-details',
            label: 'Trust Information',
            questions: [
                { label: 'What is the contract ID?', answer: 'CON12345' },
                { label: 'What is the contract start date?', answer: '2023-01-01' },
                { label: 'What is the contract end date?', answer: '2024-01-01' },
                { label: 'What is the contract type?', answer: 'Full-Time' },
                { label: 'What is the contract status?', answer: 'Active' },
                { label: 'What is the contract value?', answer: '$100,000' },
            ],
        },
        {
            id: 'terms',
            label: 'Terms',
            questions: [
                { label: 'What are the payment terms?', answer: 'Net 30' },
                { label: 'What is the notice period?', answer: '30 days' },
                { label: 'What is the termination clause?', answer: 'Mutual agreement' },
                { label: 'What is the renewal clause?', answer: 'Automatic renewal' },
                { label: 'What is the confidentiality clause?', answer: 'Strictly enforced' },
                { label: 'What is the non-compete clause?', answer: '1 year' },
            ],
        },
        {
            id: 'signatories',
            label: 'Signatories',
            questions: [
                { label: 'Who is the primary signatory?', answer: 'John Doe' },
                { label: 'Who is the secondary signatory?', answer: 'Jane Smith' },
                { label: 'What is the signing date?', answer: '2023-01-01' },
                { label: 'What is the witness name?', answer: 'Alice Johnson' },
                { label: 'What is the witness signature?', answer: 'On file' },
                { label: 'What is the notary public?', answer: 'Notary Public Inc.' },
            ],
        },
      ],
      documents: [
        {
            id: 'document-list',
            label: 'Document List',
            questions: [
                { label: 'What is the document ID?', answer: 'DOC12345' },
                { label: 'What is the document title?', answer: 'Employment Contract' },
                { label: 'What is the document type?', answer: 'PDF' },
                { label: 'What is the document status?', answer: 'Approved' },
                { label: 'What is the document version?', answer: '1.0' },
                { label: 'What is the document upload date?', answer: '2023-01-01' },
            ],
        },
        {
            id: 'uploads',
            label: 'Uploads',
            questions: [
                { label: 'What is the upload ID?', answer: 'UPL12345' },
                { label: 'What is the upload date?', answer: '2023-01-01' },
                { label: 'What is the upload status?', answer: 'Completed' },
                { label: 'What is the upload type?', answer: 'Contract' },
                { label: 'What is the upload size?', answer: '2MB' },
                { label: 'What is the uploader name?', answer: 'John Doe' },
            ],
        },
        {
            id: 'revisions',
            label: 'Revisions',
            questions: [
                { label: 'What is the revision ID?', answer: 'REV12345' },
                { label: 'What is the revision date?', answer: '2023-01-01' },
                { label: 'What is the revision status?', answer: 'Approved' },
                { label: 'What is the revision type?', answer: 'Minor' },
                { label: 'What is the revision notes?', answer: 'Updated terms' },
                { label: 'What is the reviser name?', answer: 'Jane Smith' },
            ],
        },
      ],
    }
  }),

  computed:{
    active_section_tabs() {
      return this.file_tabs[this.active_file_tab];
    },
  },

  methods: {
    set_active_tab(tab) {
      this.selected_all = false;
      this.active_tab = tab;
    },

    set_active_file_tab(tabId) {
      // Define valid tab IDs to prevent unintended property access
      const validTabs = ['employee','trust_details', 'documents'];
      
      // Validate the tabId against the whitelist
      if (!validTabs.includes(tabId)) {
          tabId = 'employee'; // Fallback to default
      }

      this.active_file_tab = tabId;
      const sections = this.file_tabs[tabId] || [];
      this.active_section_tab = sections.length > 0 ? sections[0].id : null;
    },

    set_active_section_tab(tabId) {
      this.active_section_tab = tabId;
      this.selected_all = false;
    },

    scroll_left() {
      this.$refs.tabsContainer.scrollBy({ left: -200, behavior: 'smooth' });
    },

    scrollRight() {
      this.$refs.tabsContainer.scrollBy({ left: 200, behavior: 'smooth' });
    },

    toggle_all(questions) {
      // Set all checkboxes to the value of selectedAll
      questions.forEach(q => {
          q.checked = this.selectedAll;
      });
    },

    left_questions(questions) {
      return questions.slice(0, Math.ceil(questions.length / 2));
    },
  // Get right column questions (second half)
    right_questions(questions) {
      return questions.slice(Math.ceil(questions.length / 2));
    },


    verify_manually() {
      this.show_success("Successfully Verified");
    },
    request_information() {
      this.show_success("Request has been sent to trustee");
    },
  },
 
  watch: {
    selected_all(new_value) {
      // When "Select All" is checked/unchecked, update all checkboxes for the active tab
      let fields;
      switch (this.active_tab) {
        case "Personal Information": fields = this.personal_information; break;
        case "Account Manager Information": fields = this.account_manager_information; break;
        case "Trust Information": fields = this.trust_information; break;
        case "Trustee Details": fields = this.trustee_details; break;
        case "Trustee Administrator Details": fields = this.trustee_administrator_details; break;
        default: fields = [];
      }
      fields.forEach(field => {
        if (field.has_check_box) {
          field.checked = new_value;
        }
      });
    }
  }
}


  
